import Spinner from "../../Components/spinner";
import StatusBadge from "../../Components/StatusBadge";
import dateformate from "../../helper/DateFormate";
import { ViewButton } from "../../helper/ImageFormat";
import CustomPagination from "../../helper/Pagination";

const TransactionTable = ({
    loading,
    transaction,
    currentPage,
    perPage,
    totalCount,
    totalPages,
    handlePageClick,
    handleRedirect
}) => {


    return (
        <div className="row ">
            <div className="col-md-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table
                                className=" custom-table table table-striped"
                                id="myTable"
                                style={{ marginTop: "3px" }}
                            >
                                <thead>
                                    <tr>
                                        <th>Order Id</th>
                                        <th>Transaction Id</th>
                                        <th>Payment Method</th>
                                        <th>Status</th>
                                        <th>Amount</th>
                                        <th>Updated At</th>
                                        <th>View</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    {loading ? (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                <Spinner />
                                            </td>
                                        </tr>
                                    ) : transaction.length > 0 ? (
                                        transaction.map((data, id) => (
                                            <tr key={data.id}>
                                                <td>{data?.order?.orderId}</td>
                                                <td>{data?.transactionId}</td>
                                                <td>{data?.paymentMethod}</td>
                                                <td>
                                                    <StatusBadge status={data?.status} />
                                                </td>
                                                <td>{data?.order?.totalAmount}</td>
                                                <td>{dateformate(data.updatedAt)}</td>
                                                {/* <td>{dateformate(data.createdAt)}</td> */}
                                                <td>
                                                    <ViewButton handleRedirect={handleRedirect} id={data?.order?.orderId} />
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="8" className="text-center">
                                                <h4>No data available</h4>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {transaction?.length > 0 && (
                            <div>
                                <CustomPagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={handlePageClick}
                                    perPage={perPage}
                                    totalCount={totalCount}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TransactionTable;
